import { Dispatch } from 'react';
import { TOptions } from '../../../types/types';

interface DurationTabsProps {
  tabs: TOptions[];
  activeTab: string;
  setActiveTab: Dispatch<React.SetStateAction<string>>;
  setOpenModal?: Dispatch<React.SetStateAction<boolean>>;
  duration?: boolean;
  setDateRange?: (dateRange: any) => void;
  t?: (key: string) => string;
}

const DurationTabs = ({ activeTab, setActiveTab, tabs, setOpenModal, duration, setDateRange, t }: DurationTabsProps) => {
  const handleTabClick = (item: TOptions, index: number) => {
    if (index === 3 && duration) {
      setOpenModal?.(true);
    } else {
      setActiveTab(String(item.value));
      setDateRange?.(null);
    }
  };

  return (
    <ul className="duration-tabs">
      {tabs?.map((item: TOptions, index) => (
        <li onClick={() => handleTabClick(item, index)} key={item.value} className={activeTab === item?.value ? 'active' : ''}>
          {t ? t(`dashboardCharts.${item.label}`) : item.label}
        </li>
      ))}
    </ul>
  );
};

export default DurationTabs;
